//
// RenderMode.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var RenderMode = {
    AUTO:0,
    WEBGL:1,
    CANVAS2D:2,
    SVG:3
};
export default RenderMode;
